import classes from './Video.module.scss';

const VideoBlock = (props) => {
    const { url } = props.props.data.attributes;
    return (
        <div className={classes.mVideo}>
            <video className={classes.aVideo} width="320" height="240" controls>
                <source src={url} type="video/mp4" />
                <source src={url} type="video/ogg" />
                Your browser does not support the video tag.
            </video>
        </div>
    );
};

export default VideoBlock;
